import Nullstack from 'nullstack';
export default function IconCurrencyKroneDanish({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-krone-danish",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), "   ", Nullstack.element("path", {
    d: "M15 10v8"
  }), "   ", Nullstack.element("path", {
    d: "M19 10a4 4 0 0 0 -4 4"
  }), "   ", Nullstack.element("path", {
    d: "M20 18.01v-.01"
  }), " ");
}